if (!customElements.get('vt-featured-tabs')) {
  class VtFeaturedTabs extends HTMLElement {
  connectedCallback() {
    this.pills = this.querySelectorAll('[data-tab]');
    this.panels = this.querySelectorAll('[data-panel]');

    this.pills.forEach((pill, index) => {
      pill.addEventListener('click', () => this.activate(index));
    });

    this.sliders = [];
    this.panels.forEach((panel) => this.bindSlider(panel));
    this.updateAllArrows();
    window.addEventListener('resize', () => this.updateAllArrows(), { passive: true });
  }

  activate(index) {
    this.pills.forEach((pill, i) => {
      const selected = i === index;
      pill.classList.toggle('is-active', selected);
      pill.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    this.panels.forEach((panel, i) => {
      const selected = i === index;
      panel.classList.toggle('is-active', selected);
      panel.hidden = !selected;
      if (selected) {
        panel.querySelector('.vt-reveal')?.classList.add('is-visible');
      }
    });

    requestAnimationFrame(() => this.updateAllArrows());
  }

  bindSlider(panel) {
    const track = panel.querySelector('[data-track]');
    const prev = panel.querySelector('[data-prev]');
    const next = panel.querySelector('[data-next]');
    if (!track) return;

    const scrollByCard = (direction) => {
      const card = track.querySelector('.vt-feat-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      const amount = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', () => this.syncArrows(track, prev, next), { passive: true });

    this.sliders.push({ track, prev, next });
  }

  updateAllArrows() {
    this.sliders.forEach(({ track, prev, next }) => this.syncArrows(track, prev, next));
  }

  syncArrows(track, prev, next) {
    const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= max;
    const hasOverflow = max > 2;

    if (prev) {
      prev.disabled = !hasOverflow || atStart;
      prev.classList.toggle('is-hidden', !hasOverflow);
    }
    if (next) {
      next.disabled = !hasOverflow || atEnd;
      next.classList.toggle('is-hidden', !hasOverflow);
    }
  }
  }

  customElements.define('vt-featured-tabs', VtFeaturedTabs);
}
